export default __webpack_public_path__ + "static/media/fortnite-leaderboard-character.1e26377a.png";